"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlugSummary = exports.isBracketSummary = exports.isZerothChunk = void 0;
function isZerothChunk(chunk) {
    return chunk.isZeroth;
}
exports.isZerothChunk = isZerothChunk;
function isBracketSummary(summary) {
    return summary.elementType === 'bracket';
}
exports.isBracketSummary = isBracketSummary;
function isSlugSummary(summary) {
    return summary.elementType === 'slug';
}
exports.isSlugSummary = isSlugSummary;
